"use strict";

exports.__esModule = true;
exports.getPoolTVL = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
const getPoolTVL = (positions, wallet) => {
  if (!wallet.subscribePrice) return (0, _rxjs.of)(_sdkCore.FixedPointNumber.ZERO);
  const [token0, token1] = positions.info.pair;
  const [amount0, amount1] = positions.amounts;
  return (0, _rxjs.combineLatest)({
    price0: wallet.subscribePrice(token0),
    price1: wallet.subscribePrice(token1)
  }).pipe((0, _operators.map)(_ref => {
    let {
      price0,
      price1
    } = _ref;
    if (price0.isPositive() && price1.isPositive()) {
      return amount0.times(price0).add(amount1.times(price1));
    }
    if (price0.isPositive() && price1.isZero()) {
      return amount0.times(price0).times(new _sdkCore.FixedPointNumber(2));
    }
    if (price1.isPositive() && price0.isZero()) {
      return amount1.times(price1).times(new _sdkCore.FixedPointNumber(2));
    }
    return _sdkCore.FixedPointNumber.ZERO;
  }));
};
exports.getPoolTVL = getPoolTVL;